import { lazy, Suspense, useEffect, useState } from "react";

import { useTranslation } from 'react-i18next';
// Lazy-load Google OAuth provider only when needed (auth pages)
// This avoids loading the Google OAuth chunk on the landing page
let googleOAuthLoaded = false;
let GoogleOAuthProvider = null;

export function useGoogleOAuth() {
    const { t } = useTranslation();
const [ready, setReady] = useState(googleOAuthLoaded);

  useEffect(() => {
    if (googleOAuthLoaded) {
      setReady(true);
      return;
    }
    import("@react-oauth/google").then((mod) => {
      GoogleOAuthProvider = mod.GoogleOAuthProvider;
      googleOAuthLoaded = true;
      setReady(true);
    });
  }, []);

  return { ready, GoogleOAuthProvider };
}

// Wrapper component that lazily loads Google OAuth
export function LazyGoogleOAuth({ children }) {
  const [Provider, setProvider] = useState(null);

  useEffect(() => {
    import("@react-oauth/google").then((mod) => {
      setProvider(() => mod.GoogleOAuthProvider);
    });
  }, []);

  if (!Provider) {
    // Wait for the provider to load before rendering auth children.
    // This avoids mounting Google hooks outside the provider on first paint.
    return (
      <div className="min-h-screen bg-[#09090B] text-white flex items-center justify-center px-6">
        <div className="text-center">
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">Loading secure sign-up…</div>
        </div>
      </div>
    );
  }

  const GOOGLE_CLIENT_ID = "309563198472-f3e7a8bqml6j6tppp22hl4esk05mgdba.apps.googleusercontent.com";

  return (
    <Provider clientId={GOOGLE_CLIENT_ID}>
      {children}
    </Provider>
  );
}
